import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { MovementsService } from './../../../shared/services/movements.service';
import { Movement } from './../../../shared/models/movement';
import { Component, OnInit } from '@angular/core';
import { Company } from 'src/app/shared/models/companies';
import * as moment from 'moment';

@Component({
  selector: 'app-movements-default',
  templateUrl: './movements-default.component.html',
  styleUrls: ['./movements-default.component.scss']
})
export class MovementsDefaultComponent implements OnInit {
  public movements: Movement[];
  public companies: {id: string, companyName: string}[];
  public userData;

  public filters: { 
    name: string,
    lastname: string,
    cardNumber: string, 
    companyId: number, 
    email: string,
    dateStart: Date, 
    dateEnd: Date
  };

  public cardNumberEditorOptions: any;
  public companyEditorOptions: any;

  public cardNumber: string;
  public companyId: string;
  public dateStart: Date = new Date();
  public dateEnd: Date = new Date();
  public isMovementsVouchers  = false;

  constructor(
    private utilitiesService: UtilitiesService,
    private movements_service: MovementsService,
    private companies_service: CompaniesService
  ) {
    this.userData = this.utilitiesService.getUserData();
    console.log(this.userData);

    this.cardNumberEditorOptions = {
      mask: '0000  0000  0000  0000',
      maskRules: { 'X': /[0-9]/ }
    };
    this.companyEditorOptions = { 
      dataSource: this.companies, 
      valueExpr: 'companyName',
      displayExpr: 'companyId',
    };
    this.filters = {
      name: null,
      lastname: null,
      cardNumber: null,
      companyId: null,
      email: null,
      dateStart: new Date(),
      dateEnd: new Date()
    }
  }

  ngOnInit() {
    if(this.userData.level < 4) {
      this.getCompanies();
    } else {
      this.filters.companyId = this.userData.companyId;
    }
    this.getMovements();
  }

  setMovementsVouchers(e){
    this.isMovementsVouchers = e;
    console.log(e);
  }

  getCompanies() {
    this.companies_service.getCompanies().subscribe(
      (res: any) => {
        console.log(res);
        this.companies = res;
        this.companies.unshift({id: '0', companyName: 'Todos'});
      },
      error => {
        console.log(error);
    });
  }

  getMovements(e?) {
    this.filters.dateStart.setHours(0,0,0).toLocaleString();
    this.filters.dateEnd.setHours(23,59,59).toLocaleString();
    this.movements_service.getMovements(this.filters.dateStart, this.filters.dateEnd, this.filters.cardNumber, this.filters.email, this.filters.name, this.filters.lastname, this.filters.companyId,this.isMovementsVouchers).subscribe(
      (res: any) => {
        if(res.data) {
          this.movements = res.data;
          console.log(this.movements);
        }
      },
      error => {
        console.log(error);
    });
  }

  parseFiles(urls: string = '') {
    return urls.split(',').filter(f => f).map(u => Object({ url: u.trim(), name: u.substring(u.lastIndexOf('/') + 1) }));
  }

  dowloadVoucher(link: any, event: any) {
    event.preventDefault();
    this.utilitiesService.downloadFile(link.url, link.name);
  }

  trackByFn(index, item) {
    return item.name;
  }
 
  onRowPrepared(e) {
    if (e.rowType == "data" && (`${e.data?.urls || ''}`.trim() == "")) {
      e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
    }  
  }
}
